<template>
    <svg
        width="20"
        height="13"
        viewBox="0 0 20 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M0 0.5H2V2.5H0V0.5Z"
            fill="currentColor"
        />
        <path
            d="M0 5.5H2V7.5H0V5.5Z"
            fill="currentColor"
        />
        <path
            d="M0 10.5H2V12.5H0V10.5Z"
            fill="currentColor"
        />
        <path
            d="M5 0.5H19V2.5H5V0.5Z"
            fill="currentColor"
        />
        <path
            d="M5 5.5H20V7.5H5V5.5Z"
            fill="currentColor"
        />
        <path
            d="M5 10.5H16V12.5H5V10.5Z"
            fill="currentColor"
        />
    </svg>
</template>
